<template>
  <DragDialog
    title="配置目录树权限"
    :width="480"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div
      v-if="isLoading"
      class="loading-box">
      <Spin
        :pointNum="8"
        :translateX="25"
        background="var(--base-primary-bgColor)" />
    </div>
    <div
      class="config-content-box"
      v-else>
      <div class="common-input-box">
        <el-input
          class="input-primary"
          size="small"
          v-model="filterText"
          placeholder="请输入文件夹名称"
          clearable
          @clear="search"
          @keyup.enter.native="search">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="search" />
        </el-input>
      </div>
      <div class="common-tree-box">
        <el-tree
          class="tree-primary"
          ref="folderTree"
          :data="folderTreeData"
          :props="defaultProps"
          node-key="nodeId"
          :check-strictly="true"
          highlight-current
          show-checkbox
          default-expand-all
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          @check="handleNodeCheck">
          <template slot-scope="{ data }">
            <div
              class="text-overflow"
              :title="data.nodeName">
              {{ data.nodeName }}
            </div>
          </template>
        </el-tree>
      </div>
      <div class="action-btn-box">
        <div class="tip-content">
          注：勾选后，将获得对目录及其所有子目录的完全编辑权限
        </div>
        <div class="common-button-box">
          <!-- <el-button
            size="small"
            @click="invertSelection"
          >
            反选
          </el-button> -->
          <el-button
            size="small"
            class="normal-ang-btn hollowOut-btn"
            @click="cancel">
            关闭
          </el-button>
          <el-button
            size="small"
            type="primary"
            class="primary-btn primary-ang-btn"
            @click="configPermission">
            保存
          </el-button>
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import Spin from '@/components/Spin.vue'
import DragDialog from '@/components/CustomDragDialog.vue'

import {
  getUserScopeTreeService,
  updateUserScopeService
} from '@/service/memberManage'

export default {
  data() {
    return {
      isLoading: true,

      filterText: '',
      originTreeData: [],
      folderTreeData: [],

      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      }
    }
  },
  props: {
    visible: Boolean,
    userInfo: Object
  },
  components: {
    Spin,
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initFolderTree()
      } else {
        this.clearData()
      }
    }
  },
  methods: {
    initFolderTree() {
      this.queryFolderTree().then(folderTreeData => {
        this.isLoading = false

        this.folderTreeData = folderTreeData

        this.$nextTick(() => {
          let selectedNodes = this.getSelectedNodes(this.folderTreeData)
          let selectedKeys = selectedNodes.map(item => item.nodeId)
          this.$refs.folderTree.setCheckedKeys(selectedKeys)
        })
      })
    },
    search() {
      this.$nextTick(() => {
        this.$refs.folderTree.filter()
      })
    },
    filterNode(value, nodeData) {
      if (nodeData.nodeName.includes(this.filterText)) {
        return true
      } else {
        return false
      }
    },
    handleNodeCheck(nodeData) {
      let nodeObject = this.$refs.folderTree.getNode(nodeData)
      let allNodes = this.getAllNodes([nodeData])
      let allChildNodes = this.getAllNodes(nodeData.subNodes)
      let currCheckedKeys = this.$refs.folderTree.getCheckedKeys()
      if (!nodeObject.checked) {
        allNodes.forEach(item => {
          let findIndex = currCheckedKeys.findIndex(el => el === item.nodeId)
          if (findIndex !== -1) {
            currCheckedKeys.splice(findIndex, 1)
          }

          let findNode = this.findNodeById(this.folderTreeData, item.nodeId)
          this.$set(findNode, 'isSelected', false)
        })

        allChildNodes.forEach(item => {
          let findNode = this.findNodeById(this.folderTreeData, item.nodeId)
          this.$set(findNode, 'disabled', false)
        })

        this.$refs.folderTree.setCheckedKeys(currCheckedKeys)
      } else {
        let newCheckedKeys = allNodes.map(item => item.nodeId)
        let checkedKeys = [...newCheckedKeys, ...currCheckedKeys]

        allChildNodes.forEach(item => {
          let findNode = this.findNodeById(this.folderTreeData, item.nodeId)
          this.$set(findNode, 'disabled', true)
        })

        this.$refs.folderTree.setCheckedKeys(checkedKeys)
      }
    },
    invertSelection() {
      let allNodes = this.getAllNodes(this.folderTreeData)
      let allKeys = allNodes.map(item => item.nodeId)
      let checkedKeys = this.$refs.folderTree.getCheckedKeys()
      checkedKeys.forEach(nodeId => {
        let findNode = this.findNodeById(this.folderTreeData, nodeId)
        this.$set(findNode, 'isSelected', false)
      })

      let invertSelectKeys = allKeys.filter(el => !checkedKeys.includes(el))
      this.$refs.folderTree.setCheckedKeys(invertSelectKeys)
    },
    configPermission() {
      let checkedNodes = this.$refs.folderTree.getCheckedNodes()
      let nodeIds = checkedNodes.map(item => {
        let obj = { nodeId: item.nodeId, scheme: item.scheme }
        return obj
      })

      let projId = this.$route.params.projId
      let userId = this.userInfo.userId
      let params = { projId, userId, nodeIds }
      updateUserScopeService(params).then(response => {
        if (response.isSuccess) {
          this.queryFolderTree().then(folderTreeData => {
            this.folderTreeData = folderTreeData
            this.filterText = ''
            this.$message.success('配置目录树权限成功')
            this.closeDialog()
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    closeDialog() {
      this.clearData()
      this.$emit('closeDialog')
    },
    cancel() {
      if (this.isDataChanged()) {
        let warningMsg = '当前配置尚未保存，是否确认关闭窗口？'
        this.$confirm(warningMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.closeDialog()
          })
          .catch(errMsg => {
            console.log(errMsg)
          })
      } else {
        this.closeDialog()
      }
    },
    isDataChanged() {
      let isDataChanged = false
      let allNodes = this.getAllNodes(this.originTreeData)
      let originCheckedNodes = allNodes.filter(item => item.isSelected)
      let originCheckedKeys = originCheckedNodes.map(item => item.nodeId)
      let currCheckedKeys = this.$refs.folderTree.getCheckedKeys()

      if (originCheckedKeys.length !== currCheckedKeys.length) {
        isDataChanged = true
        return isDataChanged
      }

      isDataChanged = originCheckedKeys.some(
        item => !currCheckedKeys.includes(item)
      )

      return isDataChanged
    },
    queryFolderTree() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        let params = {
          projId,
          nodeName: this.filterText,
          userId: this.userInfo.userId
        }
        getUserScopeTreeService(params).then(response => {
          if (response.isSuccess) {
            let originTreeData = response.data
            this.originTreeData = JSON.parse(JSON.stringify(originTreeData))

            let folderTreeData = this.formatTreeData(originTreeData)
            resolve(folderTreeData)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    formatTreeData(treeData) {
      const recursion = item => {
        if (item.isSelected) {
          let allChildNodes = this.getAllNodes(item.subNodes)
          allChildNodes.forEach(item => {
            item.disabled = true
          })
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            recursion(subNode)
          })
        }
      }

      treeData.forEach(item => {
        recursion(item)
      })

      return treeData
    },
    // 获取接口返回的已选节点
    getSelectedNodes(data) {
      const selectedNodes = []

      const recursion = item => {
        if (item.isSelected) {
          selectedNodes.push(item)
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            recursion(subNode)
          })
        }
      }

      data.forEach(item => {
        recursion(item)
      })

      return selectedNodes
    },
    getAllNodes(data) {
      const allNodes = []
      const recursion = item => {
        allNodes.push(item)
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            recursion(subNode)
          })
        }
      }

      data.forEach(item => {
        recursion(item)
      })

      return allNodes
    },
    findNodeById(data, nodeId) {
      for (const node of data) {
        if (node.nodeId === nodeId) return node
        if (node.subNodes && node.subNodes.length) {
          const res = this.findNodeById(node.subNodes, nodeId)
          if (res) return res
        }
      }
      return null
    },
    clearData() {
      this.isLoading = true

      this.filterText = ''
      this.folderTreeData = []
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.dialog-content) {
  height: 600px;
  padding: 16px !important;
  font-size: 14px;

  .config-content-box {
    display: flex;
    flex-direction: column;
    height: 100%;

    .common-input-box {
      i {
        cursor: pointer;
      }
    }

    .el-tree {
      .el-tree-node__content {
        .el-checkbox {
          .el-checkbox__inner {
            transition: none;

            &::after {
              transition: none;
            }
          }
        }
      }
    }

    .common-tree-box {
      flex-grow: 1;
      padding: 16px 0px;
      overflow: auto;
    }

    .action-btn-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% + 32px);
      margin-left: -16px;
      padding: 16px;
      padding-bottom: 0px;
      border-top: 1px solid var(--dialog-footer-border-color);

      .tip-content {
        font-size: 12px;
        color: var(--page-tips-text-color);
      }

      .common-button-box {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
